import { useQuery } from '@tanstack/react-query'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'

import type { DiscountEligibility } from '@/dtos/exceptionalDiscount'
import { Apis } from '../appSettings/AppSettings'
import { useUrl } from '.'

export const discountEligibilityQueryKey = (insuranceId: number | undefined) => ['discountEligibility', insuranceId]

export const useDiscountEligibility = (insuranceId: number | undefined) => {
  const url = useUrl(Apis.exceptionalDiscount)

  return useQuery({
    queryKey: discountEligibilityQueryKey(insuranceId),
    queryFn: () =>
      apiClient
        .get<DiscountEligibility>(`${url}/GetEligibility`, { params: { insuranceId } })
        .then(r => r.data),
    enabled: !!insuranceId,
  })
}
